export { applySignaturesToPdf } from "./applySignaturesToPdf";
export type { SignatureBoxCoordinateType } from "./applySignaturesToPdf";
export { fillSignedConsentPdf } from "./fillSignedConsentPdf";
export type {
  RepresentativeNameType,
  InitialsBoxCoordinateType,
  NameBoxCoordinateType,
  PatientNameType,
  PcNameFormatType,
} from "./fillSignedConsentPdf";
export { mergePdfs } from "./mergePdfs";
